<template>
  <div>
    <!--选择在线素材  -->
    <el-dialog
      v-model="open"
      width="1200"
      top="5vh"
      draggable
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="openDialog"
      @close="closeDialog"
    >
      <template #header="{ titleId, titleClass }">
        <div class="dialog-header">
          <h3 :id="titleId" :class="titleClass">选择素材</h3>
        </div>
      </template>
      <div class="dialog-body">
        <div v-loading="leftData.loading" class="left-pane">
          <tree-menu
            ref="treeMenuRef"
            :data="treeData"
            :active-id="leftData.folderId"
            :default-expand-keys="leftData.folderId ? [leftData.folderId] : null"
            @node-click="handleTreeNode"
          />
        </div>

        <div class="right-pane">
          <main-layout style="height: 100% !important">
            <template #mainLayoutTop>
              <el-form ref="queryRef" :model="queryParams" :inline="true" label-suffix=":" @keyup.enter="handleQuery" class="search-box">
                <search-layout>
                  <template #searchMain>
                    <el-form-item label="素材名称" prop="name">
                      <el-input v-model.trim="queryParams.name" placeholder="请输入关键字" clearable />
                    </el-form-item>
                    <el-form-item label="素材ID" prop="id">
                      <el-input v-model.trim="queryParams.id" placeholder="请输入素材ID" clearable />
                    </el-form-item>
                  </template>
                  <template #searchAll v-if="isKnowdgeBase">
                    <el-form-item label="素材名称" prop="name">
                      <el-input v-model.trim="queryParams.name" placeholder="请输入关键字" clearable />
                    </el-form-item>
                    <el-form-item label="素材ID" prop="id">
                      <el-input v-model.trim="queryParams.id" placeholder="请输入素材ID" clearable />
                    </el-form-item>
                    <el-form-item label="视频类型" prop="videoType">
                      <el-select
                        v-model="queryParams.videoType"
                        placeholder="请选择"
                        :empty-values="[null, undefined]"
                        clearable
                        style="width: 120px"
                      >
                        <el-option label="全部" value="" />
                        <el-option label="录播" value="录播" />
                        <el-option label="直播回放" value="直播回放" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否转码" prop="isTranscode">
                      <el-select v-model="queryParams.isTranscode" placeholder="请选择" clearable style="width: 120px">
                        <el-option label="全部" :value="-1" />
                        <el-option label="未转码" :value="0" />
                        <el-option label="转码中" :value="1" />
                        <el-option label="已转码" :value="2" />
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="状态" prop="status">
                      <el-select v-model="queryParams.status" placeholder="请选择" clearable style="width: 120px">
                        <el-option label="全部" :value="-1" />
                        <el-option label="未上架" :value="0" />
                        <el-option label="已上架" :value="1" />
                      </el-select>
                    </el-form-item> -->
                    <el-form-item label="创建人" prop="createName">
                      <el-input v-model.trim="queryParams.createName" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="创建时间">
                      <date-range-picker
                        v-model:start-field="queryParams.createDateStart"
                        v-model:end-field="queryParams.createDateEnd"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                      />
                    </el-form-item>
                  </template>
                  <template #searchAll v-else>
                    <el-form-item label="素材名称" prop="name">
                      <el-input v-model.trim="queryParams.name" placeholder="请输入关键字" clearable />
                    </el-form-item>
                    <el-form-item label="素材ID" prop="id">
                      <el-input v-model.trim="queryParams.id" placeholder="请输入素材ID" clearable />
                    </el-form-item>
                    <el-form-item label="所属项目" prop="projectId">
                      <project-select v-model="queryParams.projectId" :empty-values="[null, undefined]" />
                    </el-form-item>
                    <el-form-item label="科目" prop="subjectName">
                      <el-input v-model.trim="queryParams.subjectName" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="课程" prop="courseName">
                      <el-input v-model.trim="queryParams.courseName" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="视频类型" prop="videoType">
                      <el-select
                        v-model="queryParams.videoType"
                        placeholder="请选择"
                        :empty-values="[null, undefined]"
                        clearable
                        style="width: 120px"
                      >
                        <el-option label="全部" value="" />
                        <el-option label="录播" value="录播" />
                        <el-option label="直播回放" value="直播回放" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="年份" prop="year">
                      <el-date-picker v-model="queryParams.year" type="year" format="YYYY" value-format="YYYY" style="width: 100px" />
                    </el-form-item>
                    <el-form-item label="是否关联课程" prop="isRelationCourse">
                      <el-select v-model="queryParams.isRelationCourse" placeholder="请选择" clearable style="width: 150px">
                        <el-option label="全部" :value="-1" />
                        <el-option label="未关联" :value="0" />
                        <el-option label="关联" :value="1" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否转码" prop="isTranscode">
                      <el-select v-model="queryParams.isTranscode" placeholder="请选择" clearable style="width: 120px">
                        <el-option label="全部" :value="-1" />
                        <el-option label="未转码" :value="0" />
                        <el-option label="转码中" :value="1" />
                        <el-option label="已转码" :value="2" />
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="状态" prop="status">
                      <el-select v-model="queryParams.status" placeholder="请选择" clearable style="width: 120px">
                        <el-option label="全部" :value="-1" />
                        <el-option label="未启用" :value="0" />
                        <el-option label="启用" :value="1" />
                      </el-select>
                    </el-form-item> -->
                    <el-form-item label="创建人" prop="createName">
                      <el-input v-model.trim="queryParams.createName" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="创建时间">
                      <date-range-picker
                        v-model:start-field="queryParams.createDateStart"
                        v-model:end-field="queryParams.createDateEnd"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                      />
                    </el-form-item>

                    <el-form-item label="主讲老师" prop="lecturer">
                      <el-input v-model.trim="queryParams.lecturer" placeholder="请输入" clearable />
                    </el-form-item>

                    <el-form-item label="讲次" prop="lessonNo">
                      <el-input
                        v-model.trim="queryParams.lessonNo"
                        placeholder="请输入"
                        :formatter="(val) => val && val?.replace(/\D/g, '')"
                        :parser="(val) => val?.replace(/\D/g, '')"
                        clearable
                      />
                    </el-form-item>
                  </template>
                  <template #searchFooter>
                    <el-form-item>
                      <el-button type="primary" :loading="loading" @click="handleQuery">搜索</el-button>
                    </el-form-item>
                  </template>
                </search-layout>
              </el-form>
            </template>
            <template #mainLayoutCenter>
              <el-table v-loading="loading" ref="tableRef" :data="tableData" :border="true" show-overflow-tooltip>
                <el-table-column type="selection" fixed="left" width="30" />
                <el-table-column label="名称" prop="name" fixed="left" header-align="center" min-width="240">
                  <template #default="{ row }">
                    <div v-if="[0].includes(row.fileType)" style="display: inline-flex; align-items: center; column-gap: 5px">
                      <el-icon :size="18">
                        <svg-icon icon-class="file" />
                      </el-icon>
                      <p>{{ row.name }}</p>
                    </div>
                    <div v-else-if="[1, 2].includes(row.fileType)">
                      <span v-if="!['rar', 'zip', 'm4a'].includes(row.fileExtension?.toLocaleLowerCase())">
                        <el-text type="primary" truncated size="small" @click="preview(row)" style="cursor: pointer">{{ row.name }}</el-text>
                      </span>
                      <span v-else>{{ row.name }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="类型" prop="fileType" align="center" :formatter="formatType" min-width="120" />
                <el-table-column label="视频类型" prop="videoType" align="center" min-width="120" />
                <el-table-column
                  label="素材ID"
                  prop="storageId"
                  align="center"
                  :formatter="(row, column, cellValue) => ([0].includes(row.fileType) ? '-' : cellValue)"
                  min-width="200"
                />

                <el-table-column
                  label="腾讯文件ID"
                  prop="txFileId"
                  align="center"
                  :formatter="(row, column, cellValue) => (cellValue == null ? '-' : cellValue)"
                  min-width="130"
                />
                <template v-if="isKnowdgeBase">
                  <el-table-column label="素材内容简述" prop="description" align="center" min-width="150" />
                </template>
                <template v-else>
                  <el-table-column label="所属项目" prop="projectName" align="center" min-width="180" />
                  <el-table-column label="级别" prop="level" align="center" min-width="120" />
                  <el-table-column label="所属科目" prop="subjectName" align="center" min-width="180" />
                  <el-table-column label="所属课程" prop="courseName" align="center" min-width="180" />
                  <el-table-column label="课程分类" prop="courseType" align="center" min-width="120" />
                  <el-table-column label="讲次" prop="lessonNo" align="center" min-width="120" />
                  <el-table-column label="年份" prop="year" align="center" min-width="120" />
                  <el-table-column label="主讲老师" prop="lecturerName" align="center" min-width="120" />
                </template>
                <el-table-column
                  label="大小"
                  prop="fileSize"
                  align="center"
                  :formatter="
                    (row, column, cellValue) => ([1, 2].includes(row.fileType) ? `${(Number(cellValue ?? 0) / 1024 / 1024).toFixed(2)}M` : '-')
                  "
                  min-width="120"
                />
                <el-table-column
                  label="时长"
                  prop="duration"
                  align="center"
                  :formatter="
                    (row, column, cellValue) => ([2].includes(row.fileType) ? dayjs.duration((cellValue ?? 0) * 1000).format('HH:mm:ss') : '-')
                  "
                  min-width="120"
                />
                <el-table-column label="是否转码" prop="trancodeStatus" align="center" min-width="240">
                  <template #default="{ row }">
                    <div v-if="row.fileType == 2">
                      <div>
                        <p>{{ ['未转码', '转码中', '已转码'][row.trancodeStatus] }}</p>
                      </div>
                    </div>
                    <div v-else>-</div>
                  </template>
                </el-table-column>
                <template v-if="!isKnowdgeBase">
                  <el-table-column label="直播结束时间" prop="liveTimes" align="center" min-width="150" />
                </template>

                <el-table-column label="创建人" prop="createByIdName" align="center" min-width="120" />

                <el-table-column
                  label="创建时间"
                  prop="createTime"
                  align="center"
                  :formatter="(row, column, cellValue) => (cellValue ? dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss') : '-')"
                  min-width="150"
                />

                <el-table-column label="更新人" prop="updateByIdName" align="center" min-width="120" />

                <el-table-column
                  label="更新时间"
                  prop="updateTime"
                  align="center"
                  :formatter="(row, column, cellValue) => (cellValue ? dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss') : '-')"
                  min-width="150"
                />
                <template v-if="!leftData.presentText?.includes('教学备课库')">
                  <el-table-column label="状态" prop="status" align="center" min-width="120">
                    <template #default="{ row }">
                      <div v-if="[0].includes(row.fileType)"></div>
                      <div v-else-if="[1, 2].includes(row.fileType)">
                        <template v-if="isKnowdgeBase">
                          <span>{{ ['未上架', '已上架'][row.status] }}</span>
                        </template>
                        <template v-else>
                          <span>{{ ['禁用', '启用'][row.status] }}</span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </template>
            <template #mainLayoutBottom>
              <pagination
                :hidden="!total"
                :total="total"
                layout="total, sizes, prev, pager, next"
                v-model:limit="queryParams.size"
                v-model:page="queryParams.page"
                @pagination="getList"
              />
            </template>
          </main-layout>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="default" @click="open = false">关闭</el-button>
          <el-button type="primary" @click="confirmData">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 预览云点播视频 -->
    <tc-player-dialog v-model:visible="playerVis" :video-id="currentRow.storageId" />
  </div>
</template>

<script setup>
import treeMenu from './treeMenu.vue';
import tcPlayerDialog from './tcPlayerDialog.vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { getFolderTree, searchFiles } from '@/api/education/courseContentLibrary';
import { ElMessage } from 'element-plus';

dayjs.extend(duration);
const emits = defineEmits(['confirm']);
const open = defineModel('visible', { type: Boolean, required: true, default: false });

const { proxy } = getCurrentInstance();
//左边区域文件夹目录
const leftData = reactive({
  name: undefined, //文件夹搜索参数
  folderId: undefined, //文件夹id
  folderName: undefined, //文件夹名称
  level: undefined, //文件夹层级
  presentText: undefined, //文件夹位置
  loading: false,
});

//目录dom元素
const treeMenuRef = useTemplateRef('treeMenuRef');
const treeData = ref([]);
//判断是否是仁和知识库
const isKnowdgeBase = computed(() => {
  return leftData.presentText?.includes('仁和知识库');
});

//获取文件夹树目录
async function getFolderList() {
  leftData.loading = true;
  try {
    const res = await getFolderTree({ name: leftData.name });
    treeData.value = res.data;
    leftData.loading = false;
  } catch {
    treeData.value = [];
    leftData.loading = false;
  }
}

//点击树组件节点
function handleTreeNode(data, node) {
  if (leftData.folderId !== data.id && !loading.value) {
    leftData.folderId = data.id;
    leftData.folderName = data.name;
    leftData.level = node.level;
    let parentNode = node.parent;
    let labels = [data.name];
    let level = 1;
    while (level < node.level) {
      labels = [parentNode.label, ...labels];
      parentNode = parentNode.parent;
      level++;
    }
    leftData.presentText = labels.join('/');
    nextTick(() => {
      queryRef.value && queryRef.value.resetFields();
      handleQuery();
    });
  }
}

//搜索表单
const queryRef = useTemplateRef('queryRef');
const queryParams = reactive({
  parentId: undefined,
  name: undefined,
  id: undefined,
  projectId: undefined,
  subjectName: undefined,
  courseName: undefined,
  videoType: '',
  year: undefined,
  isRelationCourse: -1,
  isTranscode: -1,
  status: 1,
  createName: undefined,
  createDateStart: undefined,
  createDateEnd: undefined,
  lecturer: undefined,
  lessonNo: undefined,
  page: 1,
  size: 50,
});
const loading = ref(false);
const tableRef = useTemplateRef('tableRef');
const tableData = ref([]);
const total = ref(0);

//点击右边搜索按钮
function handleQuery() {
  if (!leftData.folderId) {
    proxy.$modal.msgWarning('请选择文件夹');
    return false;
  }
  queryParams.page = 1;
  getList();
}

//获取表格数据
async function getList() {
  loading.value = true;
  try {
    let params = Object.assign({}, toRaw(queryParams));
    params.parentId = leftData.folderId;
    const res = await searchFiles(params);
    tableData.value = res.rows;
    total.value = res.total;
    loading.value = false;
  } catch {
    tableData.value = [];
    total.value = 0;
    loading.value = false;
  }
}

//格式化文件类型
const formatType = (row, column, cellValue) => {
  if ([1, 2].includes(cellValue)) {
    const type = row.name?.match(/\.(\w{3,4})$/i);
    return `${row.type ?? ''}${{ 1: '文件', 2: '视频文件' }[cellValue]}`;
  } else if ([0].includes(row.fileType)) {
    return '文件夹';
  }
};

//文件素材预览
const router = useRouter();
const playerVis = ref(false);
const currentRow = ref({});
async function preview(row) {
  if (row.read !== 1) {
    proxy.$modal.msgWarning('该用户没有只读权限');
    return false;
  }
  if (row.fileType == 1) {
    // 预览文件
    const baseUrl = `${location.origin}${import.meta.env.VITE_APP_BASE_API}`;
    const path = `${baseUrl}/storage/api/files/download/${row.storageId}?name=${row.storageId}.${row.fileExtension?.toLocaleLowerCase()}`;
    const route = router.resolve({ name: 'OnlinePreviewFile' });
    window.open(route.href + `?fileUrl=${encodeURIComponent(path)}`, '_blank');
  } else if (row.fileType == 2) {
    //预览视频
    playerVis.value = true;
    currentRow.value = Object.assign({}, toRaw(row));
  }
}

//弹框显示
function openDialog() {
  getFolderList();
}

//弹框关闭
function closeDialog() {
  Reflect.ownKeys(toRaw(leftData)).forEach((key) => {
    leftData[key] = undefined;
  });
  leftData.loading = false;
  queryRef.value && queryRef.value.resetFields();
  queryParams.createDateStart = undefined;
  queryParams.createDateEnd = undefined;
  tableData.value = [];
  total.value = 0;
}

//点击确定按钮
function confirmData() {
  const list = tableRef.value.getSelectionRows();
  if (list.length == 0) {
    ElMessage({ type: 'warning', message: '请先进行勾选' });
    return;
  }
  emits('confirm', list);
  open.value = false;
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  .el-dialog__header {
    padding: 0 16px;
    margin: 0;
    .dialog-header {
      box-sizing: border-box;
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      .el-dialog__title {
        width: fit-content;
        margin: 0;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .el-dialog__body {
    .dialog-body {
      width: 100%;
      height: 65vh;
      display: inline-flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      .left-pane {
        flex: none;
        box-sizing: border-box;
        width: 300px;
        height: 100%;
        padding-right: 10px;
        border-right: 2px solid #e6e6e6;
        overflow: auto;
      }

      .right-pane {
        flex: auto;
        box-sizing: border-box;
        width: calc(100% - 300px);
        height: 100%;
        padding-left: 10px;
        overflow: auto;
        .el-form {
          .el-form-item {
            .el-form-item__label {
              white-space: nowrap;
              font-weight: 400;
            }
            .el-form-item__content {
              > .el-input {
                --el-input-width: 240px;
              }
              > .el-select {
                --el-select-width: 240px;
              }
              > .el-date-editor {
                --el-date-editor-daterange-width: 240px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
